import { FormattedMessage } from 'react-intl'

const RecordsCount = ({ count, total, msgId }) => {
  return (
    <FormattedMessage
      id={msgId ?? "generic.foundRecords"}
      values={{
        count: count,
        total: total,
        b: (chunks) => <span className="bolder">{chunks}</span>,
      }}
    />
  )
}

export default RecordsCount
